import React, { createContext, useState } from "react";
export const AdvancedOptionsContext = createContext(void 0);
export const AdvancedOptionsProvider = ({ children }) => {
  const [isAdvancedOptionsVisible, setAdvancedOptionsVisibility] = useState(false);
  return /* @__PURE__ */ React.createElement(
    AdvancedOptionsContext.Provider,
    {
      value: {
        isAdvancedOptionsVisible,
        setAdvancedOptionsVisibility
      }
    },
    children
  );
};
